import { z } from "zod";

import { scheduleIdlePostHogLoad } from "@/lib/posthog-lazy";

// Earliest client entry, loaded on every route — nothing heavy may be
// imported statically here. Rationale + trade-offs: src/lib/posthog-lazy.ts.
//
// `zod` is the one exception, and only because it is already here: the
// @tripcart/shared barrel re-exports `validation/human-error-map.ts`, which
// imports zod, and enough client routes reach that barrel for webpack to put
// zod in the chunk EVERY route loads. Measured 2026-09-17 on a prod build:
// present on `/`, `/tours/` and `/tours/[slug]/`. So this import costs no
// bytes. If zod ever genuinely leaves the client bundle, delete these two
// lines rather than leaving them — they would then be what puts it back.
//
// WHY HERE and not somewhere tidier. Two other homes were tried and failed:
//   - A NEW `src/instrumentation-client.ts`. Next resolves this filename from
//     `src/` when it exists, so that file SHADOWED this one and silently
//     disabled PostHog on every public route.
//   - `installHumanErrorMap()` in @tripcart/shared, guarded on `window`.
//     Measured: the eval violation came straight back, so something builds a
//     schema before that install runs. Config after the first probe is too
//     late.
// This entry runs before any of it, which is the property that matters.
//
// WHAT IT BUYS: zod 4 decides whether to JIT-compile validators by probing
// `Function("")`. Our CSP has no `'unsafe-eval'`, so the probe throws, zod
// catches it and interprets instead — identical validation either way. But
// Chrome records the blocked eval and Lighthouse fails `inspector-issues` for
// any recorded issue, which capped Best Practices at 96. `jitless` means there
// is no probe, so there is nothing to record. The CSP is untouched.
z.config({ jitless: true });

scheduleIdlePostHogLoad();
